export const {
  apiUrl,
  appControllerCode,
  appControllerImplementations,
  appUpdated,
  blockManifests,
  definition,
  demoMode,
  development,
  displayAppMemberName,
  displayInstallationPrompt,
  enableSelfRegistration,
  id: appId,
  languages,
  logins,
  pageManifests,
  sentryDsn,
  sentryEnvironment,
  showAppsembleLogin,
  showAppsembleOAuth2Login,
  showDemoLogin,
  snapshotId,
  vapidPublicKey,
} = window.settings;
// @ts-expect-error This is intentional
delete window.settings;
